import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
// ⚠ DEEP PATH, DELIBERATE — do not "tidy" to the package barrel. See .claude/context/code-splitting.md.
import { CustomerProvider } from '@thd-olt-functional/customer-information/dist/components/CustomerProvider';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { App } from './app/App';
import { getIsInIframe, waitForIdle } from './shared/utils/assistant-utils';

const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

// Promotes the preloaded stylesheet on demand. See .claude/context/app-bootstrap.md.
function activateStyles() {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll('link[data-magic-apron-css][rel="preload"]')
    .forEach((link) => link.setAttribute('rel', 'stylesheet'));
}

function renderApp(container) {
  const app = (
    <React.StrictMode>
      <ErrorBoundary name="magic-apron-assistant-loader">
        <ExperienceProvider value={experienceContext}>
          {/* MAG4-838: B2B shoppers saw wrong OOS state without a customer context. */}
          <CustomerProvider>
            <App activateStyles={activateStyles} />
          </CustomerProvider>
        </ExperienceProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  // React 18/19 uses createRoot instead of render, but we want to maintain compatibility with React 16 for now.
  // It will check for createRoot and use it if available.
  if (typeof ReactDOM.createRoot === 'function') {
    ReactDOM.createRoot(container).render(app);
  } else {
    ReactDOM.render(app, container);
  }
}

// MAG4-850 iframe mount guard. See .claude/context/app-bootstrap.md.
if (typeof BroadcastChannel !== 'undefined' && !getIsInIframe()) {
  waitForIdle(() => {
    const container = document.getElementById('magic-apron-loader');
    if (container) {
      renderApp(container);
    }
  });
}
